import {Injectable, signal} from '@angular/core';
import {ProductPackageFile} from "../types/product-package-modal.types";

@Injectable({
  providedIn: 'root'
})
export class ProductPackageFilesStateService {
  private _productPackageFilesState = signal<Record<number, Array<ProductPackageFile>>>({});
  public productPackageFilesState = this._productPackageFilesState.asReadonly();

  public setProductPackageFilesState(id: number, productPackageFiles: Array<ProductPackageFile>): void {
    this._productPackageFilesState.set({
      ...this._productPackageFilesState(),
      [id]: productPackageFiles
    });
  }

  public getProductPackageFilesById(id: number): Array<ProductPackageFile> {
    return this.productPackageFilesState()[id];
  }

  public deleteFileById(fileId: number, productPackageId: number): void {
    this._productPackageFilesState.update(state => {
      const currentFiles = state[productPackageId] || [];
      const updatedFiles = currentFiles.filter(file => file.id !== fileId);

      return {
        ...state,
        [productPackageId]: updatedFiles
      };
    });
  }

  public updateProductPackageFilesState(productPackageId: number, productPackageFile: ProductPackageFile): void {
    this._productPackageFilesState.update(state => {
      const currentFiles = state[productPackageId] || [];
      const updatedFiles = [...currentFiles, productPackageFile];

      return {
        ...state,
        [productPackageId]: updatedFiles
      };
    });
  }

  public deleteProductPackageFilesState(productPackageId: number): void {
    this._productPackageFilesState.update(state => {
      const newState = { ...state };
      delete newState[productPackageId];
      return newState;
    });
  }
}
